import React from 'react';
const CardActions = props => {
    return (
        <div className='d-flex' style={{ gap: '1rem' }}>
            {props.children}
        </div>
    )
};
export default CardActions